import { render, staticRenderFns } from "./devenir-partenaire.vue?vue&type=template&id=b1abd4cc&scoped=true&"
import script from "./devenir-partenaire.vue?vue&type=script&lang=js&"
export * from "./devenir-partenaire.vue?vue&type=script&lang=js&"
import style0 from "./devenir-partenaire.vue?vue&type=style&index=0&id=b1abd4cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1abd4cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokImage: require('/opt/build/repo/components/StoryblokImage.vue').default,IPartenaires: require('/opt/build/repo/components/svg/Partenaires.vue').default,ILogoWordFlat: require('/opt/build/repo/components/svg/LogoWordFlat.vue').default,AppButton: require('/opt/build/repo/components/AppButton.vue').default})
